<template>
  <div class="process-content" style="overflow:hidden;">
    <div style="width: 100%">
      <el-input v-model="form.remark" :rows="4" type="textarea" />
    </div>
    <el-upload
      ref="uploader"
      class="drop-uploader"
      drag
      multiple
      action
      :headers="headers"
      :file-list="form.fileList"
      :auto-upload="false"
      :show-file-list="false"
      :on-change="toChooseFile"
      style="height: 100px;"
    >
      <div class="drop-uploader-icon">
        <i class="el-icon-upload" />
        <p style="display: inline-block;">{{ $t('SeaExport.UploadFile') }}</p>
      </div>
    </el-upload>
    <div v-if="form.fileList && form.fileList.length > 0" style="margin-top: 10px;cursor: pointer;">
      <div v-for="(file, index) in form.fileList" :key="index" class="file-style">
        <div style="margin: 7px;display: flex;">
          <i class="el-icon-paperclip" />
          <span class="file-name">{{ file.fileName }}</span>
          <span style="color: darkgray;">{{ WorkflowUtil.fileSizeLabel(file.fileSize) }}</span>
          <i style="float: right;" class="el-icon-close" @click="remove(file.fileId)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import * as ChargeItemTarget from '@/class/cargo/model/parameters/ChargeItemTarget'
import $store from '@/store'

export default {
  name: 'ProcessContent',
  props: {
    form: { type: Object, default: () => {} }
  },
  data() {
    return {
      WorkflowUtil: WorkflowUtil
    }
  },
  computed: {
    headers() {
      return {
        sessionId: this.$store.getters.token
      }
    }
  },
  methods: {
    remove(id) {
      const index = this.form.fileList.findIndex(p => p.fileId === id)
      this.form.fileList.splice(index, 1)
      const index2 = this.form.fileList2.findIndex(p => p.fileId === id)
      this.form.fileList2.splice(index2, 1)
    },
    toChooseFile(file) {
      if (file.size > 20 * 1024 * 1024) {
        this.$message.warning('1个文件体积超过20MB,不能进行上传.')
        return
      }
      const fileName = file.name
      const fileType = fileName.substr(fileName.lastIndexOf('.') + 1)
      const fileSize = file.size
      this.form.fileList.push({ fileType: fileType, fileName: fileName, file: file.raw, fileSize: fileSize })
      // CARGO-43915 BPM付款申请中上传文件同步到付款申请下的文件历史
      // 初始化固定的文件实行
      const params = {}
      params.createdBy = $store.getters.userId
      params.createdChineseName = $store.getters.userInfo.chineseName
      params.createdEnglishName = $store.getters.userInfo.englishName
      params.documentType = 'other'
      params.documentName = 'other'
      params.isShared = 'false'
      params.op = 'false'
      params.sales = 'false'
      params.cargoSales = 'false'
      params.csr = 'false'
      params.overseaOp = 'false'
      params.dc = 'false'
      params.planner = 'false'
      params.all = 'false'
      params.customer = 'false'
      params.consignee = 'false'
      params.shipper = 'false'
      params.destinationAgent = 'false'
      params.bookingAgent = 'false'
      params.synchronizationState = '0'
      params.synchronization = '0'
      params.userDefinedRoleId1 = 'false'
      params.userDefinedRoleId2 = 'false'
      params.fileSource = ChargeItemTarget.UPLOAD.code
      this.form.fileList2.push({ file: file.raw, ...params })
    }
  }
}
</script>

<style lang="scss" scoped>
  .process-content ::v-deep {
    .file-style{
      margin-top: 5px;
      width: 240px;
      height: 28px;
      background: linear-gradient(135deg,#f7faff, #ffffff);
      border-radius: 2px;
      display: inline-block;
    }
    .file-name{
      width: 60%;
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .drop-uploader .el-upload-dragger {
      width: 100%;
      height: 90%;
      background-color: transparent;
    }
  }
</style>
